import Statusbar from '../../Statusbar';

export default function youtubeExecutor({
	videoId, 
	text = '',
	start = 0,
	end = 10,
	duration = 10,
	mute = false,
}, done, { endEvent, prolong }) {
	log(`Notifications.doYoutube "${videoId}" with text "${text}"`);

	Statusbar.addStatus({ title: text });

	const durationFromStartToEnd = end - start;
	// duration comes from backend, if it is lower than calculated duration, we calculate new end
	if (durationFromStartToEnd > duration) {
		end = start + duration;
	}

	if (text || videoId) {
		if (!window.YT?.loaded && videoId) {
			log('Still waiting for YT API to load');
			Screen.logMessageToSentry('YT notification waiting for API to load');
			window.onYouTubeIframeAPIReady = function() {
				log('YT IFrame API ready');
				prolong();

				const forceEnd = playVideo({ videoId,
					text,
					start, 
					end,
					duration,
					mute }, done, prolong);

				endEvent.listeners.push(forceEnd);
			};
		} else {
			return playVideo({ videoId,
				text,
				start, 
				end,
				duration,
				mute }, done, prolong);
		}
	} else {
		done();
	}
}

function playVideo({
	videoId,
	text,
	start, 
	end,
	duration,
	mute
}, done, prolong) {
	const iframe = $('<div class="notification-youtube-iframe" allow="autoplay"/>');

	const notification = createNotificationDOMNode(iframe, videoId, text);
	Screen.elements.notifications.append(notification);
	let wasPlaying = false;
	const onEnd = () => {
		log('YT player closing');
		notification.remove();
		done();
	};

	const onForceEnd = () => {
		log('YT player closed forcefully');
		if (!wasPlaying) {
			Screen.logMessageToSentry('YT video has been forcefully closed without being played.');
		}
		onEnd();
	};

	// create the video
	if (videoId) {
		let wasBuffering = false;
		const player = new YT.Player(iframe[0], {  // YT is present onYouTubeIframeAPIReady
			width: '100%',
			height: '100%',
			videoId: videoId,
			playerVars: {
				autoplay: 1,
				controls: 0,
				disablekb: 1, // disable keyboard controls
				start: start,
				end: end,
				fs: 0,
				iv_load_policy: 3,
				modestbranding: 1,
				rel: 0,
				showinfo: 0,
				origin: 'https://app.plecto.com',
				mute: mute ? 1 : 0,
			},
			events: {
				onReady: function(event) {
					notification.removeClass('displaynone');
					event.target.setVolume(100);
					log('YT player ready');
					player.playVideo();
				},
				onStateChange: function(state) {
					switch (state.data) {
					case -1 /*unstarted*/: {
						if (wasBuffering) {
							notification.removeClass('displaynone');
							log('YT video buffered and unstarted, trying to force start...');
							player.playVideo();
						}
						
						break;
					}
					case YT.PlayerState.ENDED: {
						log('YT video ended');
						onEnd();
						break;
					}
					case YT.PlayerState.BUFFERING: {
						wasBuffering = true;
						log('YT video buffering...');
						break;
					}

					case YT.PlayerState.PAUSED: {
						log('YT video paused, closing...');
						onEnd();
						break;
					}

					case YT.PlayerState.PLAYING: {
						wasPlaying = true;
						prolong();
						notification.removeClass('displaynone');
						log('YT video playing...');
						break;
					}

					}
				},
			},
		});
	} else {

		// no video provided, still show notification text
		notification.removeClass('displaynone');
		// eslint-disable-next-line no-magic-numbers
		setTimeout(onEnd, duration * 1000);
	}

	return onForceEnd;
}

function createNotificationDOMNode(iframe, videoId, text) {
	const textDiv = $('<div class="notification-youtube-text"></div>');
	textDiv.text(text);
	const el = $('<div class="notification-youtube" />');
	if (videoId) {
		el.append(iframe);
	}
	el.append(textDiv);
	const notification = $('<div class="notification" />');
	notification.append($('<div class="overlay"></div>'));
	notification.append(el);
	notification.addClass('displaynone');
	return notification;
}
